import { gql } from '@apollo/client';

export const GET_MY_NOTIFICATIONS = gql`
  query MyNotifications($limit: Int, $offset: Int, $unreadOnly: Boolean) {
    currentUser {
      domoreNotifications(limit: $limit, offset: $offset, unreadOnly: $unreadOnly) {
        totalCount
        items {
          id
          notificationDatetime
          read
          dismissed
          presentationText
          presentationHtml
          presentationIcon
          url
          domoreEvent {
            id
            eventType
            eventDatetime
            objectType
            objectId
          }
        }
      }
    }
  }
`;
